



























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import DownloadInvoiceDownloadModal from '@/modules/invoice/components/panel/PanelInvoiceDownloadModal.vue'
import { ContentCampaignResourceType } from '@/modules/content-campaign/models/content-campaign-resource.model'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import AlertNotification from '@/modules/notification/components/panel/AlertNotification.vue'
import PanelContentCampaignEditModal
  from '@/modules/content-campaign/components/panel/PanelContentCampaignEditModal.vue'

@Component({
  components: {
    PanelContentCampaignEditModal,
    AlertNotification,
    BaseInput,
    DownloadInvoiceDownloadModal,
    Modal,
    BaseButton
  }
})
export default class PanelContentCampaignTabularActions extends Vue {
  @Prop({ required: true }) contentCampaign: ContentCampaignResourceType
  private invoiceModal = false

  get wrapperClasses() {
    return this.$q.screen.lt.md
      ? 'row q-col-gutter-sm full-width justify-center'
      : 'column'
  }

  get actionBtnClasses() {
    return this.$q.screen.lt.md
      ? 'col-4'
      : ''
  }
}
